export default {
    0: {
        claimAllPrizeSuccess: '成功领取全部奖励',
        claimAllPrizeFailed: '未能成功领取奖励',
        claimSinglePrizeSuccess: '成功领取',
        claimSinglePrizeFailed: '领取失败',
        claim: '领取',
        claimed: '查看'
    },
    1: {
        claimAllPrizeSuccess: '成功領取全部獎勵',
        claimAllPrizeFailed: '未能成功領取獎勵',
        claimSinglePrizeSuccess: '成功領取',
        claimSinglePrizeFailed: '領取失敗',
        claim: '領取',
        claimed: '查看'
    },
    2: {
        claimAllPrizeSuccess: 'Successfully claim all rewards',
        claimAllPrizeFailed: 'Fail to claim rewards',
        claimSinglePrizeSuccess: 'Successful',
        claimSinglePrizeFailed: 'Failed',
        claim: 'Claim',
        claimed: 'Check'
    },
    5: {
        // TODO 日语未支持_先用英文代替
        claimAllPrizeSuccess: 'Successfully claim all rewards',
        claimAllPrizeFailed: 'Fail to claim rewards',
        claimSinglePrizeSuccess: 'Successful',
        claimSinglePrizeFailed: 'Failed',
        claim: 'Claim',
        claimed: 'Check'
    }
};
